export default __webpack_public_path__ + "static/media/base-report17.1a5b7311.png";